import { Utils } from "../../../../../services/utils.service";
import { DataCollection } from "../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { TransportData } from "../../../../infrastructure/transportdata";

export class DashboardsFetchRequest {
  public static readonly FetchRequestType: string = "dashboard_fetch_request";


  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_ids: number[] = [];
  af_ids: number[] = [];
  asha_employee_record_ids: number[] = [];
  asha_post_ids: number[] = [];

  af_employee_record_ids: number[] = [];
  af_post_ids: number[] = [];

  bcm_employee_record_ids: number[] = [];
  bcm_post_ids: number[] = [];

  dcm_employee_record_ids: number[] = [];
  dcm_post_ids: number[] = [];

  report_filter_type: number = 0;  // Compulsory
  quarterly_year_type: number = 0;
  half_year_type: number = 0;
  month: number = 0;
  financial_year_ids: number[] = [];

  incentive_role: number = 0;

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      DashboardsFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
